import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import Router from './config/Router'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/css/main.css';
import './assets/css/animation.css';
import { Provider} from "react-redux";
import Store from "./redux/Store";
import { Language, setDefault, setTranslations } from '@react-lang/language';
import en from "./lang/en.json";
import id from "./lang/id.json";

setDefault('id');
setTranslations({ en, id });
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={Store}>
            <Language>
                <Router />
            </Language>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
